const { instance } = require('./url')

function getCompanyLogoLink(company=null) {
    return company ? '/api/companylogo/' + encodeURIComponent(company) : '/api/companylogo/'
}

// company is appended before file so the server's busboy 'field' handler
// (which the 'company' override relies on) has already fired by the time
// the file part's 'end' handler runs - see src/routers/companyLogo.js.
async function uploadCompanyLogo(file, name, onUploadProgress, company=null) {
    let formData = new FormData()
    if (company) {
        formData.append("company", company)
    }
    formData.append("file", file, name)

    return await instance.put('/companylogo/', formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        onUploadProgress,
    })
}

export {
    getCompanyLogoLink,
    uploadCompanyLogo,
}
